import React, { useState } from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PerformRealmCommunity from './RealmCommunity';
import { DivisionIcon } from 'global/components/PerformIcons';
import { map } from 'global/lib/lodash';

export default function PerformRealmDivision(props) {
  const [active, setActive] = useState(false);
  const division = props.realm;

  const toggleActive = () => {
    setActive(!active);
  };

  return (
    <>
      <ListItem button onClick={() => toggleActive()} style={{ marginLeft: 32 }}>
        <ListItemIcon>
          <DivisionIcon />
        </ListItemIcon>
        <ListItemText primary={division.name} />
      </ListItem>
      {active ? (
        <List>
          {map(division.realms, (item) => {
            return <PerformRealmCommunity key={item.id} realm={item} />;
          })}
        </List>
      ) : (
        <></>
      )}
    </>
  );
}

PerformRealmDivision.defaultProps = {
  realm: {},
  currentDivision: '0',
  changeDivision: () => {},
};

PerformRealmDivision.propTypes = {
  realm: PropTypes.object,
  currentDivision: PropTypes.string,
  changeDivision: PropTypes.func,
};
